// extracted by mini-css-extract-plugin
export default {"id":"EditRestaurantModal_id__VhBsL","upload":"EditRestaurantModal_upload__geBNf"};